import React, { Component } from 'react';

import { Provider } from 'mobx-react';
import { HashRouter as Router, Switch, Redirect, Route } from 'react-router-dom';

import SummaryPage from "./pages/summary";
import Wizard from "./components/wizard/index";
import Landing from "./components/landing/index";

class App extends Component {

  render() {
    const { stores } = this.props;
    return (
        <Provider {...stores}>
            <Router>
                <Switch>
                    <Route component={ Landing } path="/landing" />
                    <Route component={ Wizard } path="/wizard/:prjId?" />
                    <Route component={ SummaryPage } path="/summary/:prjId?/:plnId?" />
                    <Redirect from="/" exact to="/landing" />
                </Switch>
            </Router>
        </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js